import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort, MatTableDataSource } from '@angular/material';
import { ProjectsTableDataSource } from './projects-table.data';
import { Store } from '@ngrx/store';
import { IState } from '../../../shared/models/state';
import { ChangeActivityAction, ClearProjectAction } from '../projects.action';
import { initialConfig } from '../../shared/domain/initialConfig';
import { CrazyCallConfigService } from '../../shared/services/crazycall-config.service';
import { LanguageService } from '../../../shared/services/language.service';

@Component({
  selector: 'cc-projects-table',
  templateUrl: './projects-table.component.html',
  styleUrls: ['./projects-table.component.scss']
})
export class ProjectsTableComponent implements OnInit {
  public displayedColumns = ['name', 'activeType', 'domain', 'device', 'impressions', 'leads', 'conversion', 'status'];
  public matDataSource: MatTableDataSource<ProjectsTableDataSource>;

  @ViewChild(MatSort) sort: MatSort;

  constructor(
    public dataSource: ProjectsTableDataSource,
    private crazyCallConfigService: CrazyCallConfigService,
    private store: Store<IState>,
    public languageService: LanguageService
  ) {}

  ngOnInit() {
    this.store.dispatch(
      new ClearProjectAction(
        initialConfig(this.crazyCallConfigService.appId, this.languageService.getCookieLanguage() || 'en')
      )
    );
    this.dataSource.onConnect().subscribe(([data]) => {
      this.matDataSource = new MatTableDataSource(data);

      this.matDataSource.sortingDataAccessor = (tableData: any, sortHeaderId: string): string => {
        if (typeof tableData[sortHeaderId] === 'string') {
          return tableData[sortHeaderId].toLocaleLowerCase();
        }
        return tableData[sortHeaderId];
      };

      this.matDataSource.sort = this.sort;
    });
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim().toLowerCase();
    this.matDataSource.filter = filterValue;
  }

  changeActivity(project: any) {
    this.store.dispatch(new ChangeActivityAction({ projectId: project.id, active: !project.status }));
  }
}
